import { type MouseEvent, forwardRef } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const AmpouleIcon = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      d="M8.28525 12.5893L7.80408 12.7252L6.59528 10.2852C5.66151 9.97411 4.75277 9.28049 4.38429 7.97602C3.7047 5.57016 5.35755 4.06414 6.80106 3.65639C8.24458 3.24863 10.4683 3.76354 11.1207 6.07316C11.5102 7.45191 11.1336 8.53514 10.4694 9.28549L10.6911 11.9097L10.2099 12.0456M8.28525 12.5893L9.17418 13.8969L10.1365 13.6251L10.2099 12.0456M8.28525 12.5893L10.2099 12.0456"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.0345 9.16954L14.8858 10.2053M13.0454 5.5295L14.9701 4.98582M11.1317 2.43313L12.1674 0.581862M2.47057 4.87967L0.619296 3.84391M2.45965 8.51971L0.534967 9.06338M4.37343 11.6161L3.33767 13.4673"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
